import { createApi } from '@quotetome/materials-api'
import useAuthStore from 'src/stores/auth'

export const api = {}

export default ({ app }) => {
  const authStore = useAuthStore()
  const axios = app.config.globalProperties.$axios

  Object.assign(api, createApi(axios, () => authStore.authToken, { authPrefix: 'Bearer' }))
  app.provide('$api', api)
}
